<p-card data-cy="payment-method-container">
  <div
    class="mb-3 sm:mb-4 flex justify-content-between"
    [ngClass]="{
      'flex-row align-items-center': !editMode && ((paymentMethods$ | async)?.length || 0) > 1,
      'flex-column align-items-start sm:flex-row sm:align-items-center':
        editMode || (!editMode && (paymentMethods$ | async)?.length === 1)
    }"
  >
    <h3 class="my-0">Payment Method</h3>
    <button
      *ngIf="(!editMode && (paymentMethods$ | async)?.length === 1) || editMode"
      pButton
      type="button"
      label="Add new payment method"
      icon="mi-round mi-add-circle-outline"
      class="p-button-text p-button-sm mt-2 sm:mt-0"
      (click)="showModal()"
      data-cy="add-new-payment-method-button"
      appClickEvent
      eventName="order_wizard_add_payment_method"
    ></button>
    <button
      *ngIf="!editMode && ((paymentMethods$ | async)?.length || 0) > 1"
      pButton
      type="button"
      label="Change"
      icon="mi-round mi-edit"
      class="p-button-text p-button-sm"
      (click)="switchToEdit()"
      data-cy="change-payment-method-button"
      appClickEvent
      eventName="order_wizard_change_payment_method"
    ></button>
  </div>
  <div
    *ngIf="
      (isPaymentMethodTouched && (selectedPaymentMethod$ | async) === null) ||
      (selectedPaymentMethod$ | async) === undefined
    "
  >
    <app-message severity="error" data-cy="error-required-payment-method-message"
      >Please add a payment method.
    </app-message>
  </div>
  <div *ngIf="isPaymentMethodTouched && isPaymentMethodExpired(selectedPaymentMethod$ | async)">
    <app-message severity="error" data-cy="error-expired-credit-card-message">
      This credit card is expired. Please choose or create a different payment method.
    </app-message>
  </div>
  <div *ngIf="!editMode">
    <div
      *ngIf="(paymentMethods$ | async)?.length === 0"
      class="empty-payment-method-container border-grey-100 py-4 px-4 sm:px-7 border-1"
    >
      <button
        pButton
        type="button"
        label="Add your payment method"
        icon="mi-round mi-add-circle-outline"
        class="p-button-text p-button-sm"
        (click)="showModal()"
        data-cy="add-new-payment-method-button"
        appClickEvent
        eventName="order_wizard_add_payment_method"
      ></button>
    </div>
    <app-payment-method-details
      *ngIf="selectedPaymentMethod$ | async"
      [paymentMethod]="(selectedPaymentMethod$ | async)!"
    ></app-payment-method-details>
  </div>
  <div *ngIf="editMode">
    <app-payment-method-radio
      [control]="asFormControl(paymentMethodsForm.get('selectedPaymentMethodId'))"
      name="selectedPaymentMethodId"
    ></app-payment-method-radio>
    <div class="mt-5">
      <app-form-footer
        submitLabel="Use Payment Method"
        [small]="true"
        [handleCancel]="onCancel.bind(this)"
        [handleSubmit]="onSubmit.bind(this)"
      ></app-form-footer>
    </div>
  </div>
</p-card>

<app-payment-method-form
  [(visible)]="displayModal"
  (submitForm)="onPaymentMethodCreated($event)"
></app-payment-method-form>
